import { observer } from 'mobx-react-lite'
import type { DateTimeQuestionAnswerEditorViewModel } from '@/features/jobs/questions/date-time/DateTimeQuestionAnswerEditorViewModel'
import { DateTimeQuestionAnswerEditor } from './index'

interface DateTimeQuestionAnswerEditorContainerProps {
  questionId: string
  editorVm: DateTimeQuestionAnswerEditorViewModel
  'aria-labelledby'?: string
  'aria-describedby'?: string
  isDisabled?: boolean
}

export const DateTimeQuestionAnswerEditorContainer = observer(
  function DateTimeQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    ...rest
  }: DateTimeQuestionAnswerEditorContainerProps) {
    return (
      <DateTimeQuestionAnswerEditor
        collectTime={editorVm.collectTime}
        value={editorVm.value}
        onChange={editorVm.respond}
        min={editorVm.minDate}
        max={editorVm.maxDate}
        testId={`datetime-question-answer-editor-${questionId}`}
        {...rest}
      />
    )
  },
)
